<script setup lang="ts">
import { NotivueItem } from 'notivue';
import BaseToast from './BaseToast.vue';
import type { NotivueItemProps } from './base-toast.types';

interface Props {
  item: NotivueItem<NotivueItemProps>;
}

defineProps<Props>();
</script>

<template>
  <BaseToast :item="item">
    <template #icon>
      <IconifyIcon
        icon="mdi:warning-circle-outline"
        width="40px"
        class="text-amber-500"
      ></IconifyIcon>
    </template>
    <template #content>
      <h3 class="text-base font-bold">{{ item.title }}</h3>
      <p class="text-sm" :role="item.ariaRole" :aria-live="item.ariaLive">
        {{ item.message }}
      </p>
    </template>
  </BaseToast>
</template>

<style scoped></style>
